import $ from 'jquery';
export default function edvPartnerNavigation() {

     // Hide/Show level 2
     $('.edv-main-menu .nav-item').mouseenter(function (){
         let link = $(this).find('nav-link');
         link.addClass('show');
         link.attr('aria-expanded','true');
         $(this).find('.dropdown-menu').addClass('show');
     });
     $('.edv-main-menu .nav-item').mouseleave(function (){
            let link = $(this).find('nav-link');
            link.removeClass('show');
            link.attr('aria-expanded','false');
            $(this).find('.dropdown-menu').removeClass('show');
     });
     // Redirect on click level 2
     $('.edv-main-menu .nav-link.dropdown-toggle').click(function(e){
        e.preventDefault();
        window.location.href = $(this).attr('href');
     });
    // Hide/Show level 2 nav-item description
    $('.edv-main-menu .level-2-items > li').mouseenter(function (){
        let navitemID = $(this).attr('data-navitem');
        let navitemDesc = $('.nav-item-desc[data-navitem="'+navitemID+'"]');
        let navitemDescCurrent = $('.nav-item-desc[data-navitem="'+navitemID+'"].current-sub-menu-item');
        navitemDesc.css('z-index','2');
        navitemDesc.css('opacity','2');
    });
    $('.edv-main-menu .level-2-items > li').mouseleave(function (){
        let navitemID = $(this).attr('data-navitem');
        let navitemDesc = $('.nav-item-desc[data-navitem="'+navitemID+'"]');
        navitemDesc.css('z-index','0');
        navitemDesc.css('opacity','0');
        if($('.level-2-items-desc .nav-item-desc.current-sub-menu-item').length > 0 ) {
            $('.level-2-items-desc .nav-item-desc.current-sub-menu-item').css('z-index','1').css('opacity','1');
        } else {
            $('.level-2-items-desc .nav-item-desc:first-child').css('z-index','1').css('opacity','1');
        }

    });
    $('.edv-main-menu .level-2-items-desc > li').mouseenter(function (){
        let navitemID = $(this).attr('data-navitem');
        let navitem = $('.level-2-items li[data-navitem="'+navitemID+'"]');
        navitem.addClass("current-hover");
        $(this).css('z-index','2');
        $(this).css('opacity','2');
    });
    $('.edv-main-menu .level-2-items-desc > li').mouseleave(function (){
        let navitemID = $(this).attr('data-navitem');
        let navitem = $('.level-2-items li[data-navitem="'+navitemID+'"]');
        navitem.removeClass("current-hover");
        $(this).css('z-index','0');
        $(this).css('opacity','0');
        if($('.level-2-items-desc .nav-item-desc.current-sub-menu-item').length > 0 ) {
            $('.level-2-items-desc .nav-item-desc.current-sub-menu-item').css('z-index','1').css('opacity','1');
        } else {
            $('.level-2-items-desc .nav-item-desc:first-child').css('z-index','1').css('opacity','1');
        }
    });
    //Scroll
    let originalHeightPageMenu = $('.edv-page-menu').height();
    let originalHeightMainMenu = $('.edv-main-menu').height();
    let originalLogoWidth = $('.navbar-brand img').width();
    $(window).scroll(function() {
        if ($(this).scrollTop() > 0) {
            $('.edv-page-menu').css('height', '10px');
            $('.edv-main-menu').css('height', '80px');
            $('.edv-main-menu .navbar-nav .dropdown-menu').css('top', '80px');
            $('.edv-page-menu .nav-item').css('display','none');
            $('.navbar-brand img').css('width','220px');

        } else {
            $('.edv-page-menu').css('height', originalHeightPageMenu + 'px');
            $('.edv-main-menu').css('height', originalHeightMainMenu + 'px');
            $('.edv-main-menu .navbar-nav .dropdown-menu').css('top', '100px');
            $('.edv-page-menu .nav-item').css('display','block');
            $('.navbar-brand img').css('width', originalLogoWidth + 'px');
        }
    });

    //mobile
    $('.edv-nav-mobile .edv-mobile-grid .nav-link-3.nav-link-level-2').click(function(e){
        if($(this).siblings('.dropdown-menu-2').hasClass("d-none")) {
            $(this).siblings('.dropdown-menu-2').removeClass("d-none");
            $('.edv-nav-mobile .nav-link-level-2').addClass("nav-show");
        } else {
            $(this).siblings('.dropdown-menu-2').addClass("d-none");
            $('.edv-nav-mobile .nav-link-level-2').removeClass("nav-show");
        }

    });
    $('.edv-nav-mobile .nav-link.dropdown-toggle').click(function(e){
        $('.edv-nav-mobile .dropdown-menu-2').addClass("d-none");
        $('.edv-nav-mobile .nav-link-level-2').removeClass("nav-show");
        $('.edv-nav-mobile .dropdown-menu-3').addClass("d-none");
    });

    $('.edv-nav-mobile .level-2-subitem .nav-link-3.dropdown-toggle-3').click(function(e){
        if($(this).siblings().hasClass("d-none")) {
            $(this).siblings().removeClass("d-none");
        } else {
            $(this).siblings().addClass("d-none");

        }
        $(this).parent().siblings().find('.dropdown-menu-3').addClass("d-none");
    });


    $('.navbar-toggler').click(function() {
        if (!$('.edv-nav-mobile').hasClass('show')) {
            $('.edv-nav-mobile').addClass('show');
        } else {
            setTimeout(function() {
            $('.edv-nav-mobile').removeClass('show');
            }, 300);
        }
    });


}